export interface Route {
   id: string;
   label: string;
   icon: string;
   path: string;
}

export const Routes: Route[] = [
   {
      id: 'customer',
      label: 'Customer Portal',
      icon: 'customer_portal',
      path: 'customer',
   },
   {
      id: '4pl',
      label: '4PL Portal',
      icon: '4pl_portal',
      path: '4pl',
   },
   {
      id: 'vendor',
      label: 'Vendor Portal',
      icon: 'vendor_portal',
      path: 'vendor',
   },
   {
      id: 'agent',
      label: 'Agent Portal',
      icon: 'agent_portal',
      path: 'agent',
   },
];

export const RoutesById: {[ key: string ]: Route } = {};
Routes.map( r => RoutesById[r.id] = r );
